export default {

	async page_list (params) {

		const [ sites ] = await Promise.all([
			Anvil.models.c_order.SiteList.fetch()
		])

        /*
		const search = new Anvil.models.Record({
			machine_id: params.machine_id || null
		})
        */

		await Anvil.renderPage('/c_order/site/page_list', { sites })
	},

	async action_refresh () {

        const [ sites ] = await Promise.all([
			Anvil.models.c_order.SiteList.fetch()
		])

		Anvil.page.sites = sites
		Anvil.models.components.Grid.find('#site_grid').list = sites
	},

	async modal_edit (company_db_id, id) {

		const [ site ] = await Promise.all([
			Anvil.models.c_order.Site.fetch(company_db_id, id)
		])

		await Anvil.modal('/c_order/site/modal_edit', { site })
	},

	async action_geocode (address) {
		return await Anvil.REST.post(`/geoapify/geocode`, { address })
	},

	async action_save (site) {

		// Tell the record to commit
		await site.record.commit()

		Anvil.toast.success('Elmentve', 'Az telephely adatainak mentése sikeres')

		return true
	}
}